<div class="detail-content-scroll">
    <tr *ngFor="let depth of depth_detail?.result">
        <td class="depth-date">{{ depth.date | date:'dd/MM/yyyy' }}</td>
        <td class="depth-value">{{ depth.value | number:'1.2-2' }} {{ isPiezo ? "m" : "L/s"}}</td>
    </tr>
</div>